import React, { useState } from 'react';
import Alert from 'Components/Alert';
import FieldSet from 'Components/FieldSet';
import FormGroup from 'Components/Form/FormGroup';
import FormLabel from 'Components/Form/FormLabel';
import SelectInput from 'Components/Form/SelectInput';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import PageToolbar from 'Components/Page/Toolbar/PageToolbar';
import PageToolbarButton from 'Components/Page/Toolbar/PageToolbarButton';
import PageToolbarSection from 'Components/Page/Toolbar/PageToolbarSection';
import Table from 'Components/Table/Table';
import TableBody from 'Components/Table/TableBody';
import TableRow from 'Components/Table/TableRow';
import TableRowCell from '../components/TdarrTableRowCell';
import { align, icons, kinds } from 'Helpers/Props';
import { useTdarrLibraries, useTdarrPieStats } from '../queries';
import { TdarrPieEntry } from '../types';

const columns = [{ name: 'name', label: 'Name', isVisible: true, isSortable: false }, { name: 'value', label: 'Files', isVisible: true, isSortable: false }, { name: 'share', label: 'Share', isVisible: true, isSortable: false }];
function Distribution({ entries }: { entries?: TdarrPieEntry[] }) {
  const total = entries?.reduce((sum, entry) => sum + entry.value, 0) ?? 0;
  return entries?.length ? <Table columns={columns} horizontalScroll={false}><TableBody>{entries.map((entry) => <TableRow key={entry.name || 'unknown'}><TableRowCell>{entry.name || 'Unknown'}</TableRowCell><TableRowCell>{entry.value}</TableRowCell><TableRowCell>{total ? `${(entry.value / total * 100).toFixed(1)}%` : '0%'}</TableRowCell></TableRow>)}</TableBody></Table> : <Alert>No data available</Alert>;
}

export default function Stats() {
  const [libraryId, setLibraryId] = useState('');
  const libraries = useTdarrLibraries();
  const stats = useTdarrPieStats(libraryId);
  const pies = stats.data?.pieStats;
  const overviewColumns = columns.slice(0, 2);
  return <PageContent title="Stats">
    <PageToolbar><PageToolbarSection alignContent={align.LEFT}><PageToolbarButton label="Refresh" iconName={icons.REFRESH} isSpinning={stats.isFetching} onPress={() => stats.refetch()} /></PageToolbarSection></PageToolbar>
    <PageContentBody>
    <FieldSet legend="Statistics Filter"><FormGroup><FormLabel name="statsLibrary">Library</FormLabel><SelectInput<string> name="statsLibrary" value={libraryId} values={[{ key: '', value: 'All Libraries' }, ...(libraries.data ?? []).map((library) => ({ key: library._id, value: library.name }))]} onChange={({ value }) => setLibraryId(value)} /></FormGroup></FieldSet>
    {stats.isError && <Alert kind={kinds.DANGER}>Unable to load Tdarr statistics.</Alert>}
    {pies && <>
      <FieldSet legend="Overview"><Table columns={overviewColumns} horizontalScroll={false}><TableBody>
        <TableRow><TableRowCell>Files</TableRowCell><TableRowCell>{pies.totalFiles}</TableRowCell></TableRow>
        <TableRow><TableRowCell>Transcodes</TableRowCell><TableRowCell>{pies.totalTranscodeCount}</TableRowCell></TableRow>
        <TableRow><TableRowCell>Health Checks</TableRowCell><TableRowCell>{pies.totalHealthCheckCount}</TableRowCell></TableRow>
        <TableRow><TableRowCell>Space Saved</TableRowCell><TableRowCell>{pies.sizeDiff.toFixed(2)} GB</TableRowCell></TableRow>
      </TableBody></Table></FieldSet>
      <FieldSet legend="Video Codecs"><Distribution entries={pies.video.codecs} /></FieldSet>
      <FieldSet legend="Containers"><Distribution entries={pies.video.containers} /></FieldSet>
      <FieldSet legend="Resolutions"><Distribution entries={pies.video.resolutions} /></FieldSet>
      <FieldSet legend="Audio Codecs"><Distribution entries={pies.audio.codecs} /></FieldSet>
      <FieldSet legend="Audio Containers"><Distribution entries={pies.audio.containers} /></FieldSet>
      <FieldSet legend="Transcode Status"><Distribution entries={pies.status.transcode} /></FieldSet>
      <FieldSet legend="Health Check Status"><Distribution entries={pies.status.healthcheck} /></FieldSet>
    </>}
  </PageContentBody></PageContent>;
}
